import type { WebApp } from '@twa-dev/types';
import { useCallback, useMemo } from 'react';

declare global {
  interface Window {
    Telegram: {
      WebApp: WebApp;
    };
  }
}

export const useTelegram = () => {
  const telegramWebApp = useMemo(() => {
    if (!window.Telegram?.WebApp) {
      console.warn('Telegram WebApp not found');
      return {} as WebApp;
    }

    const webApp = window.Telegram.WebApp;
    webApp.expand();
    webApp.setHeaderColor('#1A1A1A');

    webApp.disableVerticalSwipes();
    webApp.isOrientationLocked = true;

    return webApp;
  }, []);

  const showAlert = useCallback((message: string) => {
    if (window.Telegram?.WebApp?.showAlert) {
      window.Telegram.WebApp.showAlert(message);
    } else {
      console.warn('Telegram WebApp not available, fallback to alert:', message);
      alert(message);
    }
  }, []);

  const hapticFeedback = (type: 'light' | 'medium' | 'heavy' | 'rigid' | 'soft' = 'light') => {
    if (window.Telegram?.WebApp?.HapticFeedback) {
      window.Telegram.WebApp.HapticFeedback.impactOccurred(type);
    }
  };

  const getBotUsername = useCallback(() => {
    return telegramWebApp.initDataUnsafe?.start_param || 'MAFIA_KULT_BOT';
  }, [telegramWebApp]);

  return {
    telegramWebApp,
    initData: telegramWebApp.initData,
    initDataUnsafe: telegramWebApp.initDataUnsafe,
    user: telegramWebApp.initDataUnsafe?.user,
    hapticFeedback,
    botUsername: getBotUsername(),
    showAlert,
  };
};
